const EducationExperienceInstitutionLevel = {
  Unknown: "UNKNOWN",
  HighSchool: "HIGH_SCHOOL",
  BachelorCollege: "BACHELOR_COLLEGE",
  BachelorUniversity: "BACHELOR_UNIVERSITY",
  MasterUniversity: "MASTER_UNIVERSITY",
  PhdUniversity: "PHD_UNIVERSITY"
};

export { EducationExperienceInstitutionLevel };
//# sourceMappingURL=education-experience-institution-level.mjs.map
